export const UNDEFINED = "UNDEFINED";

export const CHOOSE = "CHOOSE";

export const ALL_BUNKS = [1,2,3,4,5,6]